import { render, staticRenderFns } from "./DashFornecedorNotaDebito.vue?vue&type=template&id=a2116516"
import script from "./DashFornecedorNotaDebito.vue?vue&type=script&lang=js"
export * from "./DashFornecedorNotaDebito.vue?vue&type=script&lang=js"
import style0 from "./DashFornecedorNotaDebito.vue?vue&type=style&index=0&id=a2116516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports